/**
 * AP-32 14.1 — **Versand eines Belegs**: Vorlage und Senden über die Endpunkte des
 * Belegwesens. Liegt hier, nicht im Belegwesen, weil der Versanddialog auch aus
 * anderen Modulen aufgerufen wird (AP-37 Detailblatt O 6.4, O-14): Er ist ein
 * gemeinsamer Baustein wie die Filterleiste.
 */
import type { AttachmentDelivery } from '@symphenia/shared-types'
import { api } from '@/lib/axios'

export interface SendDraft {
  to: string[]
  contacts: { name: string; email: string; role: string }[]
  subject: string
  message: string
  /** Antworten gehen an den sendenden Benutzer (14.2). */
  replyTo: string
  /** Ein Brief, der als Entwurf hinausgeht (9.1). */
  draftLetter: boolean
  /** Nachtrag 4: Dateien an Positionen, die neben dem PDF mitgehen — AP-10 Nachtrag 2: als Anhang oder Link. */
  attachments?: { fileName: string; sizeBytes: number; delivery?: AttachmentDelivery; deliveryMicrosoft365?: AttachmentDelivery }[]
  /** AP-10 Nachtrag 2: bis wann die Links gelten (YYYY-MM-DD), wenn eine Datei als Link geht. */
  linkValidUntil?: string | null
  /** AP-10 Nachtrag 3: Die Link-Dateien gehen als eine ZIP-Datei hinaus. */
  linkAsZip?: boolean
  /** AP-10 Nachtrag 1: welche Wege der Dialog anbietet. */
  transports?: {
    microsoft365: { status: 'OK' | 'EXPIRED'; address: string | null } | null
    system: { address: string } | null
  }
  /** `null` = Pflicht zum eigenen Postfach ohne gültige Verbindung — Senden gesperrt. */
  defaultTransport?: 'MICROSOFT_365' | 'SYSTEM' | null
  /** Darf verbinden, hat aber noch nicht. */
  connectHint?: boolean
  /** AP-27 7. (RB-19): Dateien aus der Herkunft der Zeilen (Regieberichte) — vorgeschlagen, abwählbar, immer Anhang. */
  sourceAttachments?: { key: string; fileName: string; label: string }[]
}

export interface SendPayload {
  to: string[]
  cc?: string[]
  copyToSelf?: boolean
  subject: string
  message: string
  /** AP-10 Nachtrag 1: ohne Angabe gilt die Vorwahl des Mandanten. */
  transport?: 'MICROSOFT_365' | 'SYSTEM'
  /** Die gewählten Schlüssel aus `sourceAttachments`. */
  sourceAttachments?: string[]
}

export const versand = {
  vorlage: (id: string) => api.get<{ data: SendDraft }>(`/documents/${id}/send`),
  /** Nachtrag 10: eigene Dateien — dann als Formular (`mail` als JSON, Dateien in `files`), sonst JSON. */
  senden: <T,>(id: string, payload: SendPayload, dateien: readonly File[] = []) => {
    if (!dateien.length) return api.post<{ data: T }>(`/documents/${id}/send`, payload)
    const formular = new FormData()
    formular.append('mail', JSON.stringify(payload))
    for (const d of dateien) formular.append('files', d, d.name)
    return api.post<{ data: T }>(`/documents/${id}/send`, formular)
  },
  lesen: <T,>(id: string) => api.get<{ data: T }>(`/documents/${id}`),
}
